export const UPDATE_CURRENT_DEPTH = "UPDATE_CURRENT_DEPTH";
export const UPDATE_EXTENSION = "UPDATE_EXTENSION";
export const CLEAR_EXTENSION = "CLEAR_EXTENSION";
export const ONE_STEP_BACK = "ONE_STEP_BACK";
export const RESET_SELECTIONS = "RESET_SELECTIONS";
export const UPDATE_SHOWN_STATE = "UPDATE_SHOWN_STATE";
